import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const FACET_CHIP_CONFIGS = [
	{
		facetName: 'training_and_events_categories',
		containerSelector: '.facetwp-facet-training_and_events_categories',
		chipLabel: 'All topics',
	},
];

function getFacetContainer(block, containerSelector) {
	return block.querySelector(containerSelector);
}

function addFacetChip(block, { facetName, containerSelector, chipLabel }) {
	const container = getFacetContainer(block, containerSelector);
	if (!container) return;
	if (container.querySelector(`[data-js="${facetName}-chip"]`)) return;

	const chip = document.createElement('button');
	chip.type = 'button';
	chip.className = 'facetwp-checkbox all-topics-chip';
	chip.setAttribute('data-js', `${facetName}-chip`);
	chip.textContent = chipLabel;

	chip.addEventListener('click', () => {
		if (!window.FWP) return;
		const currentValue = window.FWP.facets?.[facetName];
		window.FWP.facets[facetName] = Array.isArray(currentValue) ? [] : '';
		window.FWP.refresh();
	});

	container.prepend(chip);
}

function updateFacetChipState(block, { facetName }) {
	const chip = block.querySelector(`[data-js="${facetName}-chip"]`);
	if (!chip || !window.FWP) return;

	const selected = window.FWP.facets?.[facetName] || [];
	const selectedCount = Array.isArray(selected) ? selected.length : String(selected).trim().length;
	chip.classList.toggle('is-active', selectedCount === 0);
}

function updateCountsLabel(block) {
	const label = block.querySelector('[data-js="te-counts-label"]');
	if (!label || !window.FWP?.settings?.pager) return;

	const pager = window.FWP.settings.pager;
	const totalRows = Number(pager.total_rows || 0);
	const page = Math.max(1, Number(pager.page || 1));
	const perPage = Math.max(1, Number(pager.per_page || 1));

	if (totalRows <= 0) {
		label.textContent = 'Showing 0 resources';
		return;
	}

	const start = (page - 1) * perPage + 1;
	const end = Math.min(page * perPage, totalRows);
	label.textContent = `Showing ${start} - ${end} of ${totalRows} resources`;
}

// Note: pagination scroll-to-top is handled globally by FacetWP's own
// "Scroll target" mechanism on the shared "pagination" facet (see
// inc/facetwp.php), not by per-block JS.

function initListingSpeakerSwipers(block) {
	const swipers = block.querySelectorAll('[data-js="tef-speakers-swiper"]');
	if (!swipers.length) return;

	swipers.forEach((el) => {
		if (el.swiper) return;

		const wrapper = el.closest('.media') || el.parentElement;
		const prevEl = wrapper?.querySelector('[data-js="tef-speakers-prev"]');
		const nextEl = wrapper?.querySelector('[data-js="tef-speakers-next"]');
		const paginationEl = wrapper?.querySelector('[data-js="tef-speakers-pagination"]');
		const totalSlides = Number(el.dataset.slides || 1);
		const hasManySlides = totalSlides > 1;

		new Swiper(el, {
			modules: [Navigation, Pagination],
			slidesPerView: 1,
			spaceBetween: 0,
			loop: hasManySlides,
			speed: 450,
			watchOverflow: true,
			allowTouchMove: hasManySlides,
			navigation: {
				prevEl: hasManySlides ? prevEl : null,
				nextEl: hasManySlides ? nextEl : null,
			},
			pagination: {
				el: hasManySlides ? paginationEl : null,
				clickable: true,
				bulletClass: 'tef-bullet',
				bulletActiveClass: 'is-active',
				renderBullet: (index, className) => `<span class="${className}" aria-label="Speaker ${index + 1}"></span>`,
			},
		});
	});
}

function initBlock(block) {
	FACET_CHIP_CONFIGS.forEach((config) => {
		addFacetChip(block, config);
		updateFacetChipState(block, config);
	});
	updateCountsLabel(block);
	initListingSpeakerSwipers(block);
}

export default function trainingAndEventsListingBlock() {
	const blocks = document.querySelectorAll('.training-and-events-listing-block');
	if (!blocks.length) return;

	blocks.forEach((block) => initBlock(block));

	document.addEventListener('facetwp-loaded', () => {
		blocks.forEach((block) => {
			initBlock(block);
		});
	});
}
